module.exports = __webpack_public_path__ + "img/folder_lazy.5457e20a.png";